'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ClassNameGenerator = require('../ClassNameGenerator/ClassNameGenerator.cjs');

const globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}

exports.default = generateUtilityClass;
exports.globalStateClasses = globalStateClasses;
//# sourceMappingURL=generateUtilityClass.cjs.map
